import {
  WorkflowDataResolverDependencies,
  WorkflowDefaultStepContentBlock,
} from '~/core/shared/types';
import {
  isEvaluatable,
  resolveEvaluatable,
} from '~/core/shared/utils/evaluatable';

export const evaluateDescription = (
  description: WorkflowDefaultStepContentBlock['description'],
  workflowDataResolverDependencies: WorkflowDataResolverDependencies,
) => {
  if (isEvaluatable(description)) {
    return resolveEvaluatable(description, workflowDataResolverDependencies);
  }
  return description;
};
